module.exports = __webpack_public_path__ + "static/img/none_class.6fa1951.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/none_class.png
// module id = EhdI
// module chunks = 1